import axios from "axios";
import jwt from "jwt-decode";
import toast from "react-hot-toast"

// auction-service answers 403 for any missing/bad token; only a stored login that has expired is a timeout, so a logged-out page never bounces to itself.
const hasExpiredLogin = () => {
    const accessToken = localStorage.getItem("access_token")
    if (!accessToken) return false
    try {
        return jwt(accessToken).exp * 1000 <= Date.now()
    } catch (e) {
        return true
    }
}

const initAxiosConfig = () => {
    axios.defaults.validateStatus = (status) => {
        return status;
    }

    // axios middleware
    axios.interceptors.request.use(function(config){
        return config;
    })
    
    axios.interceptors.response.use(function(response){
        if(response.status === 401 || (response.status === 403 && hasExpiredLogin())){
            toast.error("Session Timeout");
            localStorage.removeItem("access_token")
            localStorage.removeItem("refresh_token")
            location.href = "/buyer-login"
        }
        return response;
    }, function(err){
        if(err.response?.status === 401){
            localStorage.removeItem("access_token")
            localStorage.removeItem("refresh_token")
            location.href = "/buyer-login"
        }
        return Promise.reject(err);
    });
}

export default {
    initAxiosConfig
}